import { enableSentryTracing } from "@toruslabs/http-helpers";
import log from "loglevel";

import config from "@/config";

function getSampleRate() {
  try {
    return Number.parseFloat(import.meta.env.VITE_SENTRY_SAMPLE_RATE || "0.1");
  } catch {
    return 0.1;
  }
}

function getTracesSampleRate() {
  try {
    return Number.parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "0.01");
  } catch {
    return 0.02;
  }
}

export async function installSentry() {
  if (!import.meta.env.VITE_SENTRY_DSN) return;

  const [Sentry, loglevelSentryModule] = await Promise.all([import("@sentry/browser"), import("@toruslabs/loglevel-sentry")]);
  const { LoglevelSentry, redactBreadcrumbData } = loglevelSentryModule;

  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: config.buildEnv,
    release: `developer-dashboard@${import.meta.env.VITE_TORUS_BUILD_VERSION}`,
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: [
      // Happen when user click 'X' on the browser (ref https://forum.sentry.io/t/typeerror-failed-to-fetch-reported-over-and-overe/8447/2)
      "TypeError: Failed to fetch", // All except iOS and Firefox
      "TypeError: cancelled", // iOS
      "TypeError: NetworkError when attempting to fetch resource.", // Firefox
    ],
    sampleRate: getSampleRate(),
    tracesSampleRate: getTracesSampleRate(),
    normalizeDepth: 8,
    beforeBreadcrumb(breadcrumb) {
      breadcrumb.data = redactBreadcrumbData(breadcrumb.data);
      return breadcrumb;
    },
  });

  const plugin = new LoglevelSentry(Sentry);
  plugin.install(log);
  enableSentryTracing(Sentry, [config.baseRoute], ["/"]);
}

export async function setSentryEnabled(enabled: boolean | undefined) {
  const Sentry = await import("@sentry/browser");
  const client = Sentry.getClient();
  if (!client) return;

  client.getOptions().enabled = enabled;
}
